import { render, staticRenderFns } from "./BannerCustomer.vue?vue&type=template&id=9b595f74&"
import script from "./BannerCustomer.vue?vue&type=script&lang=js&"
export * from "./BannerCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports